import * as types from './actionTypes';

export function fetchGlobalSearch(payload) {
  return {
    type: types.FETCH_GLOBAL_SEARCH,
    payload
  };
}

export function fetchGlobalSearchSuccess(payload) {
  return {
    type: types.FETCH_GLOBAL_SEARCH_SUCCESS,
    payload
  };
}

export function fetchGlobalSearchFail(payload) {
  return {
    type: types.FETCH_GLOBAL_SEARCH_FAIL,
    payload
  };
}

export function fetchQuickSearch(payload) {
  return {
    type: types.FETCH_QUICK_SEARCH,
    payload
  };
}

export function fetchQuickSearchSuccess(payload) {
  return {
    type: types.FETCH_QUICK_SEARCH_SUCCESS,
    payload
  };
}

export function fetchQuickSearchFail(payload) {
  return {
    type: types.FETCH_QUICK_SEARCH_FAIL,
    payload
  };
}

export function removeQuickSearch() {
  return {
    type: types.REMOVE_QUICK_SEARCH
  };
}

export function removeGlobalSearch() {
  return {
    type: types.REMOVE_GLOBAL_SEARCH
  };
}

// ARTICLE PAGE
export const fetchArticlePageView = meta => ({ type: types.FETCH_ARTICLE_PAGE_VIEW, meta });
export const fetchArticlePageViewSuccess = response => ({ type: types.FETCH_ARTICLE_PAGE_VIEW_SUCCESS, ...response });
export const fetchArticlePageViewFail = response => ({ type: types.FETCH_ARTICLE_PAGE_VIEW_FAIL, ...response });

export function fetchProductPageView(payload) {
  return {
    type: types.FETCH_PRODUCTS_PAGE_VIEW,
    payload
  };
}

export function fetchProductCategoryPageView(payload) {
  return {
    type: types.FETCH_PRODUCTS_CATEGORY_PAGE_VIEW,
    payload
  };
}

export function fetchTestCart(payload) {
  return {
    type: types.FETCH_TEST_CART,
    payload
  };
}

export function fetchCampaignProducts(meta) {
  return {
    type: types.FETCH_CAMPAIGN_PRODUCTS,
    meta
  };
}

export function fetchCampaignProductsSuccess(response) {
  return {
    type: types.FETCH_CAMPAIGN_PRODUCTS_SUCCESS,
    ...response
  };
}

export function fetchCampaignProductsError(response) {
  return {
    type: types.FETCH_CAMPAIGN_PRODUCTS_FAIL,
    ...response
  };
}

// PRODUCT LIST
export const fetchProducts = meta => ({
  type: types.FETCH_PRODUCTS,
  meta
});

export const fetchProductsDataSuccess = response => ({
  type: types.FETCH_PRODUCTS_SUCCESS,
  ...response
});

export const fetchProductsDataError = response => ({
  type: types.FETCH_PRODUCTS_FAIL,
  ...response
});

// DETAILED PRODUCT
export const fetchProduct = meta => ({
  type: types.FETCH_PRODUCT,
  meta
});

export const fetchProductSuccess = response => ({
  type: types.FETCH_PRODUCT_SUCCESS,
  ...response
});

export const fetchProductError = response => ({
  type: types.FETCH_PRODUCT_FAIL,
  ...response
});

// DESIGNER
export function fetchDesignerData(payload) {
  return {
    type: types.FETCH_DESIGNERS_DATA,
    payload
  };
}

export function fetchDesignerDataSuccess(payload) {
  return {
    type: types.FETCH_DESIGNERS_DATA_SUCCESS,
    payload
  };
}

export function fetchDesignerDataError(error) {
  return {
    type: types.FETCH_DESIGNERS_DATA_FAIL,
    error
  };
}

export function setViewstate(key, value) {
  return {
    type: types.SET_VIEWSTATE,
    payload: { key, value }
  };
}

export function removeViewstate(key) {
  return {
    type: types.REMOVE_VIEWSTATE,
    payload: { key }
  };
}

export function fetchBrandData(payload) {
  return {
    type: types.FETCH_BRAND_DATA,
    payload
  };
}

export function fetchBrandDataSuccess(payload) {
  return {
    type: types.FETCH_BRAND_DATA_SUCCESS,
    payload
  };
}

export function fetchBrandDataFail(error) {
  return {
    type: types.FETCH_BRAND_DATA_FAIL,
    error
  };
}

export const fetchCategoryMetaData = meta => ({
  type: types.FETCH_CATEGORY_META_DATA,
  meta
});

export const fetchCategoryMetaDataSuccess = response => ({
  type: types.FETCH_CATEGORY_META_DATA_SUCCESS,
  ...response
});

export const fetchCategoryMetaDataFail = response => ({
  type: types.FETCH_CATEGORY_META_DATA_FAIL,
  ...response
});

// SHOPPING CART ACTIONS
export function fetchCart(payload) {
  return {
    type: types.FETCH_CART,
    payload
  };
}

export function fetchCartSuccess(payload) {
  return {
    type: types.FETCH_CART_SUCCESS,
    payload
  };
}

export function fetchCartFail(error) {
  return {
    type: types.FETCH_CART_FAIL,
    error
  };
}

export function addCartItem(payload) {
  return {
    type: types.ADD_PRODUCT_TO_CART,
    payload
  };
}

export function addCartItemSuccess(payload) {
  return {
    type: types.ADD_PRODUCT_TO_CART_SUCCESS,
    payload
  };
}

export function addCartItemFail(error) {
  return {
    type: types.ADD_PRODUCT_TO_CART_FAIL,
    error
  };
}

export function removeCartItem(payload, cartRow) {
  return {
    type: types.REMOVE_PRODUCT_FROM_CART,
    payload,
    cartRow
  };
}

export function removeCartItemSuccess(payload, cartRow) {
  return {
    type: types.REMOVE_PRODUCT_FROM_CART_SUCCESS,
    payload,
    cartRow
  };
}

export function removeCartItemFail(error) {
  return {
    type: types.REMOVE_PRODUCT_FROM_CART_FAIL,
    error
  };
}

export function deleteCartRow(payload, cartRow) {
  return {
    type: types.DELETE_CART_ROW,
    payload,
    cartRow
  };
}

export function deleteCartRowSuccess(payload, cartRow) {
  return {
    type: types.DELETE_CART_ROW_SUCCESS,
    payload,
    cartRow
  };
}

export function deleteCartRowFail(error) {
  return {
    type: types.DELETE_CART_ROW_FAIL,
    error
  };
}

// INSTAGRAM ACTIONS
export function fetchInstagramPosts(payload) {
  return {
    type: types.FETCH_INSTAGRAM_POSTS,
    payload
  };
}

export function fetchInstagramPostsSuccess(payload) {
  return {
    type: types.FETCH_INSTAGRAM_POSTS_SUCCESS,
    payload
  };
}

export function fetchInstagramPostsFail(error) {
  return {
    type: types.FETCH_INSTAGRAM_POSTS_FAIL,
    error
  };
}

export function fetchDeliveryMethods(payload) {
  return {
    type: types.FETCH_DELIVERY_METHODS,
    payload
  };
}

export function fetchDeliveryMethodsSuccess(payload) {
  return {
    type: types.FETCH_DELIVERY_METHODS_SUCCESS,
    payload
  };
}

export function fetchDeliveryMethodsFail(error) {
  return {
    type: types.FETCH_DELIVERY_METHODS_FAIL,
    error
  };
}



// WEBPACK FOOTER //
// ./src/actions/actionCreators.js